import EvaluateRequest from "../EvaluateRequest"
import EvaluateResult from "../EvaluateResult"
import { EvaluatorContext } from "../evaluator/Evaluator"
import FlowEvaluator from "./FlowEvaluator"

export default class EvaluationFlow<REQUEST extends EvaluateRequest, RESULT extends EvaluateResult> {
  readonly flowEvaluator: FlowEvaluator<REQUEST, RESULT> | undefined
  readonly nextFlow: EvaluationFlow<REQUEST, RESULT> | undefined

  private constructor(
    flowEvaluator: FlowEvaluator<REQUEST, RESULT> | undefined,
    nextFlow: EvaluationFlow<REQUEST, RESULT> | undefined
  ) {
    this.flowEvaluator = flowEvaluator
    this.nextFlow = nextFlow
  }

  evaluate(request: REQUEST, context: EvaluatorContext): RESULT | undefined {
    if (this.flowEvaluator && this.nextFlow) {
      return this.flowEvaluator.evaluate(request, context, this.nextFlow)
    } else {
      return undefined
    }
  }

  static end<REQUEST extends EvaluateRequest, RESULT extends EvaluateResult>(): EvaluationFlow<REQUEST, RESULT> {
    return new EvaluationFlow<REQUEST, RESULT>(undefined, undefined)
  }

  static decision<REQUEST extends EvaluateRequest, RESULT extends EvaluateResult>(
    flowEvaluator: FlowEvaluator<REQUEST, RESULT>,
    nextFlow: EvaluationFlow<REQUEST, RESULT>
  ): EvaluationFlow<REQUEST, RESULT> {
    return new EvaluationFlow<REQUEST, RESULT>(flowEvaluator, nextFlow)
  }

  static of<REQUEST extends EvaluateRequest, RESULT extends EvaluateResult>(
    ...evaluators: FlowEvaluator<REQUEST, RESULT>[]
  ): EvaluationFlow<REQUEST, RESULT> {
    let flow: EvaluationFlow<REQUEST, RESULT> = this.end()
    for (const evaluator of evaluators.reverse()) {
      flow = this.decision(evaluator, flow)
    }
    return flow
  }
}
